var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  %C₂H₆ = "+_vm._s(_vm.formatNumberValue(_vm.data.percentageC2H6))+" |\n  %CH₄ = "+_vm._s(_vm.formatNumberValue(_vm.data.percentageCH4))+" |\n  %H₂ = "+_vm._s(_vm.formatNumberValue(_vm.data.percentageH2))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }